import React from "react";
import Link from "gatsby-link";
import cx from "classnames";
import Search from "../components/Search";
import MapBar from "../components/MapBar";
import Icon from "../components/Icon";
import { checkMap } from "../util/helperFunctions";

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleToggleNav = this.handleToggleNav.bind(this);
    this.handleToggleSearch = this.handleToggleSearch.bind(this);

    this.state = {
      navOpen: false,
      searchOpen: false
    };
  }

  handleToggleNav() {
    this.setState({ navOpen: !this.state.navOpen });
  }

  handleToggleSearch() {
    this.setState({ searchOpen: !this.state.searchOpen });
  }

  render() {
    const { navOpen, searchOpen } = this.state;
    const { history, location } = this.props;

    const hideMap = checkMap(location.pathname);

    return (
      <div className="header">
        <MapBar hide={hideMap} />
        <div className="nav-bar bg-dark white relative">
          <nav className="nav-bar--mobile flex w-100 h-100 items-center justify-between">
            <Link to="/">
              <Icon path="logo-nav-mobile" className="flex" />
            </Link>
            <div className="flex h-100">
              <div
                className="pointer menu-icon h-100 flex items-center"
                aria-label="Search"
                onClick={() => {
                  this.handleToggleSearch();
                }}
              >
                <Icon
                  path="icon-18-search"
                  width="17"
                  height="17"
                  className="flex"
                />
              </div>
              <div
                className="pointer menu-icon h-100 flex items-center"
                aria-label="Navigation Menu"
                onClick={() => {
                  this.handleToggleNav();
                }}
              >
                <Icon
                  path="icon-18-menu"
                  width="17"
                  height="17"
                  className="flex"
                />
              </div>
            </div>
          </nav>
          <nav className="nav-bar--desktop h-100 dn db-l relative">
            <div className="absolute left-0 flex items-center h-100 desktop-icon-logo">
              <Link to="/">
                <Icon path="logo-nav-desktop" />
              </Link>
            </div>
            <ul className="ma0 list tc flex h-100 justify-center items-center">
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/explore-downtown/"
                  className="nav-bar--desktop__link db h-4 blue ttu h-100 flex items-center"
                >
                  Explore
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute dn z-2"
                  style={{ transform: "translateX(-65px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/riverfront-canal-walk/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Riverfront Canal Walk
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/restaurants/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Restaurants
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/shopping/"
                        className="white a-subnav o-60 db "
                      >
                        Shopping
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/outdoors/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Outdoors
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/arts-and-culture/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Arts &amp; Culture
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/attractions/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Attractions
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/explore-downtown/parking-and-transportation/"
                        className="white a-subnav o-60 db "
                      >
                        Parking &amp; Transportation
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/live-downtown/"
                  className="nav-bar--desktop__link db h-4 green ttu pointer h-100 flex items-center"
                >
                  Live
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute z-2 dn"
                  style={{ transform: "translateX(-89px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/live-downtown/historic-neighborhoods/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Historic Neighborhoods
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/live-downtown/virtual-tour/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Virtual Tour
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/live-downtown/residential-facts/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Residential Facts &amp; Figures
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/live-downtown/places-to-live/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Places to Live
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/live-downtown/living-essentials/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Living Essentials
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/work-downtown/"
                  className="nav-bar--desktop__link db h-4 brick ttu h-100 flex items-center"
                >
                  Work
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute dn z-2"
                  style={{ transform: "translateX(-82px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/work-downtown/development/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Downtown Development
                      </Link>
                    </li>

                    <li className="ma0">
                      <Link
                        to="/work-downtown/virtual-tour/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Virtual Tour
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/work-downtown/demographics/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Demographics &amp; Market Data
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/work-downtown/relocating/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Relocating
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/our-events/"
                  className="nav-bar--desktop__link db h-6 white ttu h-100 flex items-center"
                >
                  Events
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute dn z-2"
                  style={{ transform: "translateX(-82px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/our-events/friday-cheers/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Friday Cheers
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-events/dominion-energy-riverrock/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Dominion Energy Riverrock
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-events/2nd-street-festival/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        2nd Street Festival
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-events/richmond-folk-festival/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Richmond Folk Festival
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-events/camp-kanawha-halloween-cruises/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Eerie Canal Halloween Cruises
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-events/featured-events/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Featured Downtown Events
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/our-services/"
                  className="nav-bar--desktop__link db h-6 white ttu h-100 flex items-center"
                >
                  Services
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute dn z-2"
                  style={{ transform: "translateX(-82px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/our-services/riverfront-canal-cruises/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Riverfront Canal Cruises
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/browns-island-improvement-plan/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Brown's Island Improvement Project
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/downtown-marketing/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Downtown Marketing
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/clean-safe-green/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Clean, Safe &amp; Green
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/placemaking/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Placemaking
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/browns-island-rentals/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Brown's Island Rentals
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/our-services/service-district/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Service District
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100 relative nav-bar--desktop__hover-target">
                <Link
                  to="/about-us/"
                  className="nav-bar--desktop__link db h-6 white ttu h-100 flex items-center"
                >
                  About
                </Link>
                <ul
                  className="nav-bar--desktop__subnav ma0 list absolute dn z-2"
                  style={{ transform: "translateX(-82px)" }}
                >
                  <Icon
                    path="dropdown-bump"
                    height="6"
                    width="24"
                    className="dropdown-bump flex absolute top-0"
                  />
                  <div className="nav-bar--desktop__subnav-link-container bg-dark o-80">
                    <li className="ma0">
                      <Link
                        to="/about-us/our-board/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Our Board
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/our-staff/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Our Staff
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/our-contributors/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Our Contributors
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/donate/"
                        className="white a-subnav o-60 db ease-out"
                        >
                          Donate
                        </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/faq/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        FAQ
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/reports/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Reports, Publications &amp; Plans
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/about-venture-richmond/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        About Us
                      </Link>
                    </li>
                    <li className="ma0">
                      <Link
                        to="/about-us/contact-us/"
                        className="white a-subnav o-60 db ease-out"
                      >
                        Contact Us
                      </Link>
                    </li>
                  </div>
                </ul>
              </li>
              <li className="mb0 pointer h-100">
                <Link
                  to="/news/"
                  className="nav-bar--desktop__link db h-6 white ttu h-100 flex items-center"
                >
                  News
                </Link>
              </li>
            </ul>
            <div
              className="absolute top-0 white flex h-100 flex items-center search-icon"
              aria-label=""
              onClick={() => {
                this.handleToggleSearch();
              }}
            >
              <h3 className="mb0 pointer h-100">
                <a
                  href="/about-us/donate/"
                  className="nav-bar--desktop__donate db h-4 white ttu h-100 flex items-center"
                >
                  Donate
                </a>
              </h3>
              <Icon
                path="icon-18-search"
                width="17"
                height="17"
                className="flex"
              />
            </div>
          </nav>
          <Search
            history={history}
            searchOpen={this.state.searchOpen}
            handleToggleSearch={this.handleToggleSearch}
          />
        </div>
        <nav
          className={cx(
            "mobile-nav-expanded z-3 o-100 absolute bg-dark flex flex-column justify-center items-center fixed top-0 left-0 menu-fade-in",
            { "hidden o-0 menu-fade-out": !navOpen }
          )}
        >
          <div
            aria-label="Close"
            className="mobile-nav-expanded__close absolute white top-0 right-0 pointer"
            onClick={() => {
              this.handleToggleNav();
            }}
          >
            <Icon
              path="icon-18-dismiss"
              className={cx("h-100 flex rotate--45 items-center", {
                "rotate--0": navOpen
              })}
            />
          </div>
          <ul
            className="ma0 list tc"
            onClick={() => {
              this.handleToggleNav();
            }}
          >
            <li className="mb0 pointer ">
              <Link
                to="/explore-downtown/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--large db h-4 blue ttu",
                  { fadeIn: navOpen }
                )}
              >
                Explore Downtown
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/live-downtown/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--large db h-4 green ttu pointer",
                  { "fadeIn delay--2": navOpen }
                )}
              >
                Live Downtown
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/work-downtown/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--large db h-4 brick ttu pointer",
                  { "fadeIn delay--4": navOpen }
                )}
              >
                Work Downtown
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/our-events/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--small db h-5 white ttu",
                  { "fadeIn delay--6": navOpen }
                )}
              >
                Our Events
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/our-services/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--small db h-5 white ttu",
                  { "fadeIn delay--8": navOpen }
                )}
              >
                Our Services
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/about-us/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--small db h-5 white ttu",
                  { "fadeIn delay--10": navOpen }
                )}
              >
                About Us
              </Link>
            </li>
            <li className="mb0 pointer">
              <Link
                to="/news/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--small db h-5 white ttu",
                  { "fadeIn delay--12": navOpen }
                )}
              >
                News
              </Link>
            </li>
            <li className="mb0 pointer">
              <a
                href="/about-us/donate/"
                className={cx(
                  "o-0 mobile-nav-expanded__link--small db h-4 white ttu",
                  { "fadeIn delay--12": navOpen }
                )}
              >
                Donate
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js